import { render, staticRenderFns } from "./stockcensus.vue?vue&type=template&id=259c263b&scoped=true&"
import script from "./stockcensus.vue?vue&type=script&lang=js&"
export * from "./stockcensus.vue?vue&type=script&lang=js&"
import style0 from "./stockcensus.vue?vue&type=style&index=0&id=259c263b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259c263b",
  null
  
)

export default component.exports